module.exports = __webpack_public_path__ + "img/glow-yellow1-medium.b7bb73e9.png";